//require('./debug-info-modal.component.scss');

export class HddUsageModalController {
  constructor($scope, $modalInstance, ServerInformationService) {
    $scope.close = () => {
      $modalInstance.close();
    };
    $scope.hddHardLimit = ServerInformationService.hddHardLimit;
    $scope.hddUsage = ServerInformationService.hddUsage;
  }
}



// WEBPACK FOOTER //
// ./src/admin/hdd-usage-modal.component.js